import { gql } from '@apollo/client';

export const GET_ACTIVITIES_PDF_UPLOAD_URL = gql`
  query GetActivitiesPdfUploadUrl($input: GetActivitiesPdfUploadUrlInput!) {
    getActivitiesPdfUploadUrl(input: $input) {
      key
      url
    }
  }
`;
